import { CohortTranslation } from './CohortTranslation';
import { useCohortDefinitionSQLSection } from './useCohortDefinitionSQLSection';

export const CohortDefinitionSQLSection = () => {
  const { title, emptyStateMainMessage, emptyStateSubMessage, content } =
    useCohortDefinitionSQLSection();

  return (
    <CohortTranslation
      title={title}
      emptyStateMainMessage={emptyStateMainMessage}
      emptyStateSubMessage={emptyStateSubMessage}
      content={content}
    />
  );
};
